import { SET_BEEN_HOME, SHUFFLE_APPS, SET_SINGLE_APP } from './actions';
import { SHOW_LEADERS, REQUEST_RESET_STATS, GOTO_PAGE, SET_GLOBAL_OPTIONS, FORCE_UPDATE } from './actions';
import { SELECT_APP, SET_USER_ID, SET_GLOBAL_OPTION, REQUEST_SURRENDER, SET_RESTART } from './actions';
import { GLOBAL_OPTIONS_KEY, HIDE, APPS } from '../const';
import _ from 'lodash';
import { dbset } from '../utils';

export default (
  state = {
    showLeaders: HIDE,
  },
  action
) => {
  switch (action.type) {
    case SET_SINGLE_APP:
      return { ...state, singleApp: true };
    case SET_BEEN_HOME:
      return { ...state, beenHome: true, app: null, page: null };
    case SELECT_APP:
      return { ...state, app: action.app, page: null };
    case SET_USER_ID:
      return { ...state, uid: action.uid };
    case SET_GLOBAL_OPTIONS:
      return { ...state, globalOptions: action.options || {} };
    case SET_GLOBAL_OPTION:
      let globalOptions = state.globalOptions || {};
      globalOptions = { ...globalOptions, [action.payload.name]: action.payload.value };
      dbset(GLOBAL_OPTIONS_KEY, globalOptions);
      return { ...state, globalOptions };
    case GOTO_PAGE:
      return { ...state, page: action.payload.page, fromPage: action.payload.fromPage };
    case SHOW_LEADERS:
      return { ...state, showLeaders: action.op };
    case REQUEST_RESET_STATS:
      return { ...state, resetStats: action.on };
    case REQUEST_SURRENDER:
      return { ...state, surrender: action.on };
    case FORCE_UPDATE:
      return { ...state, dummy: !state.dummy };
    case SHUFFLE_APPS:
      return { ...state, apps: _.shuffle(APPS) };
    case SET_RESTART:
      return { ...state, restart: action.on };
    default:
      return state;
  }
};
